import dayjs from 'utils/dayjsSetup';

export const getDaysArray = (startDate: Date, endDate: Date): Date[] => {
  const dateArray: Date[] = [];
  if (!startDate || !endDate) {
    return dateArray;
  }
  let currentDate = dayjs.utc(startDate).startOf('day');
  dateArray.push(currentDate.toDate());
  //TODO: must be fixed properly
  while (dateArray.length <= 1000 && (currentDate.isBefore(endDate) || currentDate.isSame(endDate))) {
    currentDate = currentDate.add(1, 'day');
    dateArray.push(currentDate.toDate());
  }
  return dateArray;
};
